// extracted by mini-css-extract-plugin
export default {"avatar":"M4yukD2oyyFkDHGWzV3X"};